import { Divider } from 'antd';
import styled from 'styled-components';

import { Select } from '@style/global-style.app';

import { Card } from '@atom/card/card';
import { Text } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';

export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  min-height: 100%;
  background-color: ${ColorEnum.Black100};
  flex-direction: row;
`;

export const Section = styled.div`
  padding-top: 40px;
  display: flex;
  flex-direction: row;
  gap: 24px;
  width: 100%;
  max-width: calc(100vw - 414px);
  position: relative;
  z-index: 1;
`;

export const ColumnLeft = styled.div`
  flex: 0 0 432px;
`;

export const ColumnRight = styled.div`
  flex: 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const Layout = styled.div`
  padding-top: 48px;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 100%;
  gap: 24px;
  background-color: #f5f5f5;
`;

export const LayoutWrapper = styled.div`
  padding: 0 24px;
`;

export const CardExplorer = styled(Card).attrs({
  bordered: false,
})`
  width: 100%;
`;

export const ExplorerDivider = styled(Divider)`
  border-color: ${ColorEnum.Black90};
  margin: 24px 0;
`;

export const ExplorerDescription = styled(Text).attrs({
  color: ColorEnum.Black100,
  level: 's',
})`
  display: block;
  padding-bottom: 24px;
`;
export const ExplorerInputDescription = styled(Text).attrs({
  color: ColorEnum.Black70,
  level: 'xs',
})`
  display: block;
  padding-bottom: 4px;
`;

export const ExplorerSelect = styled(Select)`
  width: 300px;
  max-width: 300px;
  flex: 0 0 300px;
  height: 100%;
`;
